var _g;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgParcelShops({
  title,
  titleId,
  ...props
}, svgRef) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 320,
    height: 320,
    viewBox: "30 30 260 260",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M160.441 275.705c-64.147 0-116.152-52.004-116.152-116.15 0-64.146 52.005-116.15 116.152-116.15 64.147 0 116.152 52.004 116.152 116.15 0 64.146-52.005 116.15-116.152 116.15z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.286,
    d: "M119.715 238c.254 5.688 2.731 8 5.654 8h67.213c2.922 0 5.4-2.313 5.718-8l9.783-104.5h-98.215l9.847 104.5zm90.528-119.125h-14.42L190.802 102h-63.592l-5.082 16.875h-14.421L104.15 133.5h109.714l-3.62-14.625z"
  }), /*#__PURE__*/React.createElement("g", {
    transform: "translate(104.15 108.3)"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M81.55 66.937c-.006-.04-.005-.083-.013-.124a2.018 2.018 0 00-.143-.462l-.004-.016-4.2-9.3a2.1 2.1 0 00-1.914-1.235H36.75c-.825 0-1.574.483-1.913 1.236l-4.2 9.299-.005.016c-.065.146-.114.3-.143.462-.009.041-.008.083-.013.124-.011.088-.026.173-.026.262v38.734c0 1.16.94 2.1 2.1 2.1h46.926a2.1 2.1 0 002.1-2.1V67.2c0-.09-.015-.174-.027-.262z"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "38.106 60 52.017 60 51.462 65.099 35.802 65.099"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    points: "76.224 65.099 60.798 65.099 60.242 60 73.92 60"
  }), /*#__PURE__*/React.createElement("polygon", {
    fill: "#FFF",
    stroke: "#FFF",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 10.286,
    points: "106.093 16.875 91.672 16.875 86.653 0 23.061 0 17.979 16.875 3.558 16.875 0 31.5 109.714 31.5"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M77.376 103.833H34.65V69.3h16.559v6.796c0 1.16.94 2.1 2.1 2.1h5.64a2.1 2.1 0 002.1-2.1V69.3h16.327v34.534z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "M60.558 81.925a.724.724 0 00-.603.308l-3.015 4.144a.744.744 0 00.602 1.183l2.016.002-.004 7.858a.997.997 0 00.725.961c.088.025.18.035.271.035a.997.997 0 00.998-.995l.002-7.855 2.016.002a.75.75 0 00.666-.41.74.74 0 00-.061-.776l-3.007-4.15a.737.737 0 00-.606-.307M48.533 87.557h2.013l-.005 7.86a.994.994 0 00.996.998.998.998 0 00.999-.996l.004-7.86 2.015.001a.747.747 0 00.605-1.185l-3.006-4.145a.753.753 0 00-.606-.311.752.752 0 00-.606.307l-3.014 4.145a.744.744 0 00.404 1.157.806.806 0 00.201.03M62.953 98.331l-13.817-.006a.99.99 0 00-.997.992.993.993 0 00.994.998l13.816.007a.994.994 0 10.004-1.99"
  })), /*#__PURE__*/React.createElement("path", {
    stroke: "currentColor",
    strokeLinecap: "round",
    strokeLinejoin: "round",
    strokeWidth: 8.571,
    d: "M101.367 141.314c2.589-.01 117.38 0 117.38 0h-117.38z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    d: "M172.175 90.857h.282c1.16 0 2.282-.538 3.002-1.496a3.892 3.892 0 00.576-3.68c-.024-.06-2.186-6.494.57-11.7 3.539-5.955 4.611-10.683 3.278-14.393-1.24-3.412-3.998-4.429-4.556-4.579-1.963-.598-4.148.629-4.718 2.604a3.946 3.946 0 00.3 2.962 3.826 3.826 0 002.25 1.855c-.232-.06-.403-.15-.414-.15.073.21.628 2.155-2.538 7.511l-.232.39c-.22.388-.456.747-.702 1.136-4.107 6.404-5.232 11.341-3.446 15.112 1.39 2.932 4.245 4.219 6.348 4.428M147.49 90.857h.352c1.278 0 2.51-.605 3.301-1.633a4.089 4.089 0 00.624-3.932c-.042-.12-4.028-11.614 1.148-21.14 5.497-9.105 7.286-16.424 5.318-21.777-1.766-4.809-5.748-6.08-6.184-6.2-2.18-.666-4.546.635-5.188 2.782-.654 2.208.606 4.537 2.635 5.112.024.03.587.302.908 1.18.473 1.27.978 5.262-4.5 14.365l-.2.333c-.418.696-.87 1.422-1.36 2.147-6.335 9.709-8.234 17.36-5.642 22.714 2.087 4.325 6.487 5.807 8.789 6.05"
  }))));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgParcelShops);
export default __webpack_public_path__ + "static/media/parcelShops.42c004b3.svg";
export { ForwardRef as ReactComponent };